import { Component, ViewChild } from '@angular/core';
import { CarrierStatus, CustomerStatus, LoadCarrierBidStatus, PermissionModuleCode, CreditRequestStatus, FileExtension, IncidentStatus, EdiLoadTenderListStatus, RateConfirmationStatus, PurchaseJournalStatus, AccountDocumentType, LoadStatus, AvailUnavailStatus, PermissionCode, ActiveInactiveStatus, FacilityStatus, ListActionType, LoadCarrierBidStage, LoadCheckCallStatus } from '@app/core/constants/enums';
import { LoginHelper } from '@app/core/helpers/login.helper';
import { LoadService } from '@app/modules/load/load.service';
import { OverlayPanel } from 'primeng/overlaypanel';
import { distinctUntilChanged } from 'rxjs';
import { UserDetailModel } from '@app/core/models/user-detail.model';
import { ICellRendererParams } from '@ag-grid-community/core';

@Component({
  selector: 'app-list-actions',
  templateUrl: './list-actions.component.html',
  styles: [
  ]
})
export class ListActionsComponent {
  params!: ICellRendererParams | any;
  module = PermissionModuleCode;
  customerStatusEnum: typeof CustomerStatus = CustomerStatus;
  loadBidStatus = LoadCarrierBidStatus;
  creditRequestStatusEnum = CreditRequestStatus;
  carrierStatusEnum: typeof CarrierStatus = CarrierStatus;
  fileExtensionEnum: typeof FileExtension = FileExtension;
  availUnavailStatus: typeof AvailUnavailStatus = AvailUnavailStatus;
  incidentStatusEnum: typeof IncidentStatus = IncidentStatus;
  ediLoadTenderStatus: typeof EdiLoadTenderListStatus = EdiLoadTenderListStatus;
  rateConfirmationStatus: typeof RateConfirmationStatus = RateConfirmationStatus;
  purchaseJournalStatus: typeof PurchaseJournalStatus = PurchaseJournalStatus;
  accountDocumentType: typeof AccountDocumentType = AccountDocumentType;
  activeInactiveStatus: typeof ActiveInactiveStatus = ActiveInactiveStatus;
  checkcallStatus: typeof LoadCheckCallStatus = LoadCheckCallStatus;
  ediProcessFlag!: boolean;
  loadStatus: typeof LoadStatus = LoadStatus;
  @ViewChild('overlayPanel') overlayPanel!: OverlayPanel;
  @ViewChild('editPanel') editPanel!: OverlayPanel;
  permission = PermissionCode;
  facilityStatus: typeof FacilityStatus = FacilityStatus;
  facilityButtonText: typeof ActiveInactiveStatus = ActiveInactiveStatus;
  listActionType = ListActionType;
  ediTenderStatus: typeof EdiLoadTenderListStatus = EdiLoadTenderListStatus;
  bidStage = LoadCarrierBidStage;

  constructor(private readonly loadService: LoadService) {
    this.loadService.overlayPanelSubject$.pipe(distinctUntilChanged()).subscribe(() => {
      this.overlayPanel?.hide();
    });
    this.loadService.editPanelSubject$.pipe(distinctUntilChanged()).subscribe(() => {
      this.editPanel?.hide();
    });
  }

  agInit(params: ICellRendererParams) {
    this.params = params;
  }

  edit() {
    this.params.onEditClick(this.params?.node?.data);
  }

  editInnerException() {
    this.params.onEditClickInnerException(this.params?.node?.data);
  }

  editPayLoad() {
    this.params.onEditClickPayLoad(this.params?.node?.data);
  }

  viewPdf() {
    this.params.onPdfViewer(this.params?.node?.data);
  }

  markDNU() {
    this.params.onMarkDNU(this.params?.node?.data);
  }

  markActive() {
    this.params.onMarkActive(this.params?.node?.data);
  }

  updateStatus() {
    this.params.onUpdateStatusClick(this.params?.node?.data);
  }

  setDefault() {
    this.params.onSetAsDefaultClick(this.params?.node?.data);
  }

  refresh(params: ICellRendererParams) {
    this.params = params;
    return true;
  }

  assignRep() {
    this.params.onAssignSalesRep(this.params?.node?.data);
  }

  remove() {
    this.params.onDeleteClick(this.params?.node?.data);
  }

  approveRequest() {
    this.params.onApproveDialogClick(this.params?.node?.data);
  }

  rejectRequest() {
    this.params.onRejectDialogClick(this.params?.node?.data);
  }

  approveBidRequest(): void {
    this.params.onRejectApproveBidClick(this.params?.node?.data);
  }

  rejectBidRequest(): void {
    this.params.onRejectRejectBidClick(this.params?.node?.data);
  }

  viewDocument(): void {
    this.params.onViewDocumentClick(this.params?.node?.data);
  }

  deleteDocument(): void {
    this.params.onDeleteDocumentClick(this.params?.node?.data);
  }

  downloadDocument(): void {
    this.params.onDownloadDocumentClick(this.params?.node?.data);
  }

  onViewerClick(): void {
    this.params.onViewerClick(this.params?.node?.data);
  }

  revert() {
    this.params.onRevertClick(this.params?.node?.data);
  }

  editRecord() {
    this.params.onEditClick(this.params?.node?.data);
  }

  viewDocuments() {
    this.params.onDocumentClick(this.params?.node?.data);
  }

  viewInvoice() {
    this.params.onInvoiceClick(this.params?.node?.data);
  }

  resolveIncident(response: any) {
    this.params.onResolveClick(response);
  }

  resolutionInformation() {
    this.params.onInformationClick(this.params?.node?.data);
  }

  assignEdiTender() {
    this.params.onAssignEdiTender(this.params?.node?.data);
  }

  processEdiTender() {
    this.params.processEdiTender(this.params?.node?.data);
  }

  snooze(): void {
    this.params.onSnoozeClick(this.params?.node?.data);
  }
  highVisibility(): void {
    this.params.onHighVisibilityClick(this.params?.node?.data);
  }
  manageCheckCall(): void {
    this.params.onManageCheckCallClick(this.params?.node?.data);
  }
  manageIncidents(): void {
    this.params.onManageIncidentsClick(this.params?.node?.data);
  }

  onApRevert(): void {
    this.params.onRevertClick(this.params?.node?.data);
  }

  onApEdit() {
    this.params.onEditClick(this.params?.node?.data);
  }

  onApDocument() {
    this.params.onDocumentClick(this.params?.node?.data);
  }



  onAuditReviewEdit(): void {
    this.params.onAuditReviewEdit(this.params?.node?.data);
  }

  onRelese() {
    this.params.onRelese(this.params?.node?.data);
  }

  onAudtitReviewDocument() {
    this.params.onAudtitReviewDocument(this.params?.node?.data);
  }

  viewEDIPayload(): void {
    this.params.onViewClick(this.params?.node?.data);
  }
  assignViewsClick() {
    this.params.assignViewsClick(this.params?.node?.data);
  }

  toggleOverlayPanel(event: Event, overlayPanel: any): void {
    this.loadService.setOverlayPanel(this.params?.node?.data.loadIncidentId);
    overlayPanel.toggle(event);
  }

  ediUpdateIcon() {
    this.params.onEdiUpdateIconClick(this.params?.node?.data);
  }

  assignCapacity() {
    this.params.onAssignClick(this.params?.node?.data);
  }

  loadDocument() {
    this.params.onLoadDocumentsClick(this.params?.node?.data);
  }

  loadActivitiesClick() {
    this.params.onLoadActivitiesClick(this.params?.node?.data);
  }

  processEdi(ediLoadTenderStatus: any) {
    if (ediLoadTenderStatus && ediLoadTenderStatus === this.ediLoadTenderStatus.Pending) {
      this.ediProcessFlag = true;
    }
    return this.ediProcessFlag;
  }

  isEDIProcessVisible(): boolean {
    return LoginHelper.IsModuleAccessible(PermissionModuleCode.EDIManagement, PermissionCode.AcceptLoadTender) ||
      LoginHelper.IsModuleAccessible(PermissionModuleCode.EDIManagement, PermissionCode.DeclineLoadTender);
  }

  isViewLoadDocumentsPermitted(): boolean {
    return LoginHelper.IsModuleAccessible(PermissionModuleCode.DocumentManagement, PermissionCode.ViewDocumentonLoad);
  }

  getCurrentUser(): UserDetailModel {
    return LoginHelper.GetUserDetail();
  }

  syncPaymentClick() {
    this.params.onSyncPaymentClick(this.params?.node?.data);
  }

  downloadReportDocument(): void {
    this.params.onDownloadDocumentClick(this.params?.node?.data);
  }


  hasImplicitePermission(params: any, explicitPermission: boolean): boolean {
    return explicitPermission ||
      params?.loggedInUser === params?.node?.data.accountManagerId ||
      params?.loggedInUser ===
      params?.node?.data.carrierOperationsRepresentativeId ||
      params?.loggedInUser ===
      params?.node?.data.customerOperationsRepresentativeId ||
      params?.loggedInUser === params?.node?.data.managerId ||
      params?.loggedInUser === params?.node?.data.accountOwnerId ||
      params?.loggedInUser === params?.node?.data.deskOwnerId ||
      params?.loggedInUser === params?.node?.data.executiveSponsorId ||
      params?.loggedInUser === params?.node?.data.carrierRepId
      ? true
      : false;
  }

  onIntergrationSyncClick() {
    this.params.onIntergrationSyncClick(this.params?.node?.data);
  }

  renewCarrierPreferredLane() {
    this.params.renewCarrierPreferredLane(this.params?.node?.data);
  }

  cloneLoadClick(): void {
    this.params.onCloneLoad(this.params?.node?.data);
  }

  toggleEditPanel(event: Event, editPanel: any): void {
    this.loadService.setEdiPanel(this.params?.node?.data.documentId);
    editPanel.toggle(event);
  }

  editDocument(response: any) {
    this.params.onEditClick(response);
  }

  onResendCheckCallClick(): void {
    this.params.onResendCheckCallClick(this.params?.node?.data);
  }

  onFacilityStatusChange(): void {
    this.params.onFacilityStatusChange(this.params?.node?.data);
  }

  onFacilityCustomerStatusChange(): void {
    this.params.onFacilityCustomerStatusChange(this.params?.node?.data);
  }

  onFacilityCustomerEdit(): void {
    this.params.onFacilityCustomerEdit(this.params?.node?.data);
  }

  onAPLoadRevert(): void {
    this.params.onAPLoadRevert(this.params?.node?.data);
  }

  onARLoadRevert(): void {
    this.params.onARLoadRevert(this.params?.node?.data);
  }

  loadQuickView(): void {
    this.params.onLoadQuickView(this.params?.node?.data);
  }

  onViewLoadClick() {
    this.params.onViewLoadClick(this.params?.node?.data);
  }

  onCapacityLoadClick() {
    this.params.onCapacityLoadClick(this.params?.node?.data);
  }

  editFleet(): void {
    this.params.onEditFleetClick(this.params);
  }

  saveFleet(): void {
    this.params.onSaveFleetClick(this.params?.node?.data);
  }

  cancelFleet(): void {
    this.params.onCancelFleetClick(this.params?.node?.data);
  }

  onReActivateLoadTenderClick() {
    this.params.onReActivateLoadTenderClick(this.params?.node?.data);
  }

  onReTenderLoadClick() {
    this.params.onReTenderLoadClick(this.params?.node?.data);
  }

  onReactivateLoadClick(): void {
    this.params.onReactivateLoadClick(this.params?.node?.data);
  }

  onSyncLoadDetailToElasticSearch(): void {
    this.params.onSyncLoadDetailToElasticSearch(this.params?.node?.data);
  }

  onMatchesClick() {
    this.params.onMatchesClick(this.params?.node?.data);
  }

  onLoadQuickView() {
    this.params.onLoadQuickView(this.params?.node?.data);
  }

  onExpireClick() {
    this.params.onExpireClick(this.params?.node?.data);
  }

  counterCapacity() {
    this.params.onCounterClick(this.params?.node?.data);
  }

  onCheckcallEditClick() {
    this.params.onCheckcallEditClick(this.params?.node?.data);
  }

  showCheckCallEdit(): boolean {
    const status = this.params?.node?.data?.loadCheckCallStatusUI ?? this.params?.node?.data?.loadCheckCallStatusName;
    return (status === this.checkcallStatus.AtPickup || status === this.checkcallStatus.AtDestination)
      && this.params?.checkCallOverridePermission;
  }

  canEditCheckCall(): boolean {
    const disabledLoadStatuses = [
      this.loadStatus.Billing,
      this.loadStatus.Closed,
      this.loadStatus.Cancelled,
      this.loadStatus.Review,
      this.loadStatus.ArAging
    ];
    return !disabledLoadStatuses.includes(this.params?.loadStatus);
  }
}